module.exports = __webpack_public_path__ + "img/3@2x.f305b98c.png";